<template>
  <b-modal
    id="resend-otp-via-email"
    class="custom-modal"
    centered
    body-class="py-3"
    hide-footer
    no-close-on-backdrop
    @hidden="clearModal"
    hide-header
  >
    <b-form-group>
      <div class="d-flex align-items-start">
        <p class="pt-3">Please enter your email address where you want to receive the OTP.</p>
        <b-button
          class="bg-transparent close p-0 shadow-none"
          @click.self="$root.$emit('bv::hide::modal', 'resend-otp-via-email')">
          &times;
        </b-button>
      </div>
    </b-form-group>
    <b-form-group label="Enter Email Address">
      <b-form-input
          v-model="form.email"
          placeholder="Enter Email Address"
          @keypress.native="filterAlphaNumericPunctuations"
          :state="isInvalid('email')"
          :maxlength="maxEmailCharacters"
        >
        </b-form-input>
        <b-form-invalid-feedback :state="isInvalid('email')">
          {{ errorMessage("email") }}
        </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <b-button
        variant="primary"
        class="text-white text-uppercase"
        pill
        block
        @click="validateField"
        :disabled="isLoading">
        Send OTP
      </b-button>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import notification from "@/services/notification";

function initForm() {
  return {
    email: null
  }
}

export default {
  name: "ResendOtpViaEmail",
  data() {
    return {
      form: initForm(),
      maxEmailCharacters: 100
    }
  },
  computed: {
    ...mapGetters("auth", ["errors", "isLoading"])
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["sendOtpEmail"]),
    clearModal() {
      this.form = initForm();
      this.setErrors(null);
    },
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9 @._\s\-]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isValidEmail(input) {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      return emailRegex.test(input);
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    validateField() {
      const errors = {};

      if (!this.form.email) errors["email"] = "Email is required";
      else if (this.form.email && !this.isValidEmail(this.form.email)) errors["email"] = "The email must be a valid email address.";

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitForm();
      else notification.warning("Oops, something went wrong.");
    },
    async submitForm() {
      await this.sendOtpEmail({
        email: this.form.email,
        action: "FORGOT_PIN_EMAIL"
      })
        .then(() => {
          if (this.errors === null || Object.keys(this.errors).length === 0) {
            this.$root.$emit("bv::hide::modal", "resend-otp-via-email");
          }
        })
    }
  }
}
</script>
